<script setup lang="ts">
import { EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const { locale } = useI18n()
const { $notyf } = useNuxtApp()
const url = useRequestURL()
const config = useNuxtApp().$config

// booker
const isNavBookerVisible = ref()
provide('isNavBookerVisible', isNavBookerVisible)
const bookerTarget = ref<HTMLElement | null>(null)
provide('bookerTarget', bookerTarget)

// sections
const pageSections = ref<IHomePageSectionModel[]>()
const pageMetaObject = ref<{ [key: string]: string } | undefined>()
const pageHeaderSection = ref<ICMSLocationContent>()
const pageTextSection = ref<ICMSLocationContent>()
const pageFaqSection = ref<ICMSLocationContent>()
const metaContent = ref<ICMSLocationContentTranslations>()
provide('pageHeaderSection', pageHeaderSection)
provide('pageTextSection', pageTextSection)
provide('pageFaqSection', pageFaqSection)
provide('pageSections', pageSections)
const subpagesContentStore = useSubpagesContentStore()
const getPageSections = async () => {
	try {
		const response = await subpagesContentStore.fetchPageSections('delivery-bus-rental')
		pageSections.value = response
		pageHeaderSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.PAGE_HEADER_IMAGE)
		pageMetaObject.value = pageSections.value?.find((section) => section.name === EPageSectionType.META)
		pageTextSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.CONTENT_SECTION)
		pageFaqSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.FAQ)
		metaContent.value = pageMetaObject.value?.translations.find((translation) => translation.language === locale.value)?.content[0]
	} catch (error) {
		$notyf.error('Error while fetching page sections')
		console.log(error)
	}
}

await getPageSections()

const robotsCalculated = computed(() => {
	if (!metaContent.value?.robots || metaContent.value?.robots?.length === 0) return undefined
	return metaContent.value?.robots.join(', ')
})
</script>

<template>
	<div>
		<!-- definePageMeta -->
		<Head>
			<Title>{{ metaContent?.title ? metaContent?.title : `${$t('pages.deliver_bus_rental.header')} | CarFree` }}</Title>
			<Meta name="description" :content="metaContent?.description ?? ''" />
			<Meta v-if="config.public.environment === 'production-to-change' && robotsCalculated" name="robots" :content="robotsCalculated ?? ''" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link rel="canonical" :href="metaContent?.canonical && metaContent?.canonical?.trim() !== '' ? metaContent?.canonical : url.href" />
		</Head>

		<GlobalHeader booker />
		<CarRentalPageHero :title="$t('pages.delivery_bus_rental.header')" booker />
		<HomePageChooseCar :modal-form="true" :min-months="1" :max-months="12" :oneGroup="EGroupName.DELIVERY" init />
		<LazyVisibleLongTermPageBenefits hydrate-on-visible />
		<!-- <LongTermPageSpecialOffer image="medium-term-special-offer.png" :type="ESpecialDailyOfferType.MID_TERM" :min-months="1" :max-months="12" /> -->
		<LazyVisibleLongTermPageContact
			:min-val="1"
			:max-val="12"
			:label="EFormLabel.MONTHS"
			hydrate-on-visible
			:timeframe="EContactFormRentalTimeframe.LONG_TERM" />
		<LazyVisibleCarRentalTextSection hydrate-on-visible />
		<LazyVisibleCarRentalFaq :pageTitle="$t('components.nav.mega_menu.delivery_van_rental')" hydrate-on-visible />
		<LazyVisibleGlobalApplicationBanner :without-margin="true" hydrate-on-visible />
		<LazyVisibleGlobalFooter hydrate-on-visible />
	</div>
</template>
